import React, { useState ,useEffect} from "react";
import "../../App.css";
import "../claimWrapp/claimWrapp.css";
import { useLocation } from "react-router-dom";

function ClaimWrapp({ data }) {
  const [spend, setSpend] = useState(200);
  const location = useLocation();

  // Calculate estimated compensation dynamically
  const estimatedCompensation = Math.round(spend * 0.25 * 85 * 0.18);

  const isLoading = !data || Object.keys(data).length === 0;

  useEffect(() => {

    if (location.hash === "#settlement") {

      setTimeout(() => {
        const el = document.getElementById("settlement");

        if (el) {
          const yOffset = -150;
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 200);

    }

  }, [location]);

  return (
    <section className="claim-wrapp-new" id="settlement">
      <div className="container">
        {isLoading ? (
          <>
            {/* Skeleton for heading */}
            <div className="skeleton skeleton-title"></div>

            <div className="estimator-layout row">
              <div className="col-md-7">
                <div className="skeleton skeleton-box"></div>
              </div>
              <div className="col-md-5">
                <div className="skeleton skeleton-box"></div>
              </div>
            </div>

            <div className="skeleton skeleton-line"></div>
            <div className="skeleton skeleton-btn"></div>
          </>
        ) : (
          <>
            {/* Actual Content */}
            <div
              dangerouslySetInnerHTML={{ __html: data?.allegationsheading }}
            />

            <div className="estimator-layout row">
              {/* Left: Calculator */}
              <div className="col-md-7">
                <div className="estimator-calculator-col">
                  <div className="estimator-calculator">
                    <label htmlFor="spend-slider" className="calculator-label">
                      <span>{data?.allegationscontent}</span>
                      <span id="spend-output">
                        {spend ? `$${spend}` : data?.allegationssubcontent}
                      </span>
                    </label>

                    {/* Range Slider */}
                    <input
                      type="range"
                      min="50"
                      max="500"
                      step="10"
                      value={spend}
                      onChange={(e) => setSpend(Number(e.target.value))}
                      id="spend-slider"
                    />

                    {/* Result */}
                    <div className="calculator-result">
                      <span className="calculator-result__label">{data?.link}</span>
                      <div id="compensation-output">
                        {`~$${estimatedCompensation.toLocaleString()}`}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right: Reference Examples + Key Facts */}
              <div className="col-md-5">
                <div className="estimator-info-col">
                  <div
                    className="estimator-examples"
                    dangerouslySetInnerHTML={{ __html: data?.disclaimer2 }}
                  />

                  <div
                    className="facts-list"
                    dangerouslySetInnerHTML={{ __html: data?.regbuttontext }}
                  />
                </div>
              </div>
            </div>

            {/* Disclaimer */}
            <div
              className="estimator-disclaimer"
              dangerouslySetInnerHTML={{ __html: data?.regbuttonlink }}
            />

            {/* CTA */}
            <div className="claim-cta">
              <a href="/registerpage" className="claim-btn1">
                Register to Finalise Your Claim
              </a>
            </div>
          </>
        )}
      </div>
    </section>
  );
}

export default ClaimWrapp;
